import Vue from 'vue';

import StepDocumentEntry from '@/febos/chile/dnt/components/wizard/companies/61221000-4/external/StepDocumentEntry';

export default () => ({
  currentStep: 0,
  steps: [
    {
      title: 'Ingreso de documento',
      component: StepDocumentEntry
    }
  ],
  options: ['submit'],
  submitAction: 'saveDocumentSiss',
  backupAction: 'saveDocument',
  loadAllData: true,
  wizardMapper(
    {
      dnt,
      adjuntos,
      observaciones,
      destinatarios,
      referencias
    }
  ) {
    const data = {};

    if (dnt) {
      data.typeFlow = dnt.tipoFlujo;
      data.fileNumber = dnt.numero;
      data.sender = dnt.compradorArea;
      data.senderIut = dnt.despachoContactoRut;
      data.senderName = dnt.emisorContactoNombre;
      data.senderAddress = dnt.emisorDireccion;
      data.senderComune = dnt.emisorComuna;
      data.senderEmail = dnt.emisorContactoEmail;
      data.senderPhone = dnt.despachoContactoTelefono;
      data.documentType = dnt.emisorCentroCostoNumero;
      data.documentNumber = dnt.numeroInt;
      data.isPrivate = dnt.transportePuertoTipo || 0;
      data.description = dnt.nombreDescriptivo;
      data.process = dnt.emisorSucursalCodigo;
      data.subProcess = dnt.emisorSucursalDireccion;
      data.matter = dnt.emisorContactoCargo;
      data.senderCompanyIut = dnt.emisorContactoRut;
      data.senderCompanyName = dnt.emisorContactoArea;
      data.senderAgency = dnt.transporteTransportistaCargo;
      data.subjectOffice = dnt.transporteEmbalajeTara;
      data.numberExp = dnt.numeroExt;
      data.linkToFolder = dnt.emisorInfoAdicional;
      if (dnt.fechaEmision) {
        data.issueDate = Vue.moment(dnt.fechaEmision).format('YYYY-MM-DD');
      }
      data.entryFormatFile = dnt.transporteEmbalajeSello;
      data.documentCode = dnt.emisorContactoCodigo;
      data.rifCode = dnt.transportePuertoCodigo;
      data.fileNumberEntry = dnt.condicionDespacho;
      data.numberRidex = dnt.compradorEmail;
      data.numberSac = dnt.compradorTelefono;
    }

    if (dnt.solicitanteDocumentoId) {
      data.solicitanteRut = dnt.solicitanteRut;
      data.solicitanteNombre = dnt.solicitanteNombre;
      data.solicitanteEmail = dnt.solicitanteEmail;
      data.solicitanteDocumentoId = dnt.solicitanteDocumentoId;
    }

    if (observaciones && observaciones.length) {
      data.matter = observaciones[0].observacion;
    }
    if (destinatarios && destinatarios.length) {
      const subjects = destinatarios
        .filter((subject) => subject.tipoDestino.toString() === '1')
        .map((subject) => {
          const subjectTypeDigitalDoc = subject.institucionCodigo
            ? {
              id: subject.institucionCodigoId,
              value: subject.institucionCodigo,
              label: subject.institucionNombre
            }
            : {};

          return {
            subjectType: {
              id: subject.destinoCodigoId,
              value: subject.destinoCodigo,
              label: subject.destinoNombre
            },
            subject: {
              id: subject.destinoListaCodigoId,
              value: subject.destinoListaCodigo,
              label: subject.destinoListaNombre
            },
            subjectEmail: subject.destinoCorreo,
            providence: subject.providenciaId || '',
            providenceExpiration: subject.providenciaVencimiento || '',
            dntDestinatariosId: subject.dntDestinatariosId,
            status: subject.estado,
            subjectTypeDigitalDoc
          };
        });

      data.subjects = [...subjects];
      data.subjectsSelected = [...subjects];

      const copies = destinatarios
        .filter((subject) => subject.tipoDestino.toString() === '2')
        .map((subject) => {
          const copySubjectTypeDigitalDoc = subject.institucionCodigo
            ? {
              id: subject.institucionCodigoId,
              value: subject.institucionCodigo,
              label: subject.institucionNombre
            }
            : {};

          return {
            copySubjectType: {
              id: subject.destinoCodigoId,
              value: subject.destinoCodigo,
              label: subject.destinoNombre
            },
            copySubject: {
              id: subject.destinoListaCodigoId,
              value: subject.destinoListaCodigo,
              label: subject.destinoListaNombre
            },
            copySubjectEmail: subject.destinoCorreo,
            providence: subject.providenciaId || '',
            providenceExpiration: subject.providenciaVencimiento || '',
            dntDestinatariosId: subject.dntDestinatariosId,
            status: subject.estado,
            copySubjectTypeDigitalDoc
          };
        });

      data.copies = [...copies];
      data.copiesSelected = [...copies];
    }
    if (referencias && referencias.length) {
      const relatedDocuments = referencias.map((relatedDocument) => ({
        id: relatedDocument.linea,
        type: relatedDocument.tipoDocumento,
        number: relatedDocument.folio
      }));

      data.relatedDocuments = [...relatedDocuments];
      data.relatedDocumentsSelected = [...relatedDocuments];
    }

    if (adjuntos && adjuntos.length) {
      const main = adjuntos
        .find((file) => file.tipo === 'principal');

      if (main) {
        data.mainFile = {
          mime: main.adjuntoMime,
          name: main.adjuntoNombre,
          path: main.adjuntoUrl,
          date: main.fecha,
          currentDescription: main.tipoDescripcion,
          format: main.otraReferenciaId,
          status: main.estado || 0,
          id: main.adjuntoId
        };
      }

      data.additionalFiles = adjuntos
        .filter((file) => file.tipo === 'adjunto')
        .map((file) => ({
          mime: file.adjuntoMime,
          name: file.adjuntoNombre,
          path: file.adjuntoUrl,
          date: file.fecha,
          currentDescription: file.tipoDescripcion,
          format: file.otraReferenciaId,
          status: file.estado || 0,
          id: file.adjuntoId
        }));
    }

    return data;
  },
  documentMapper(input, iutCompany, nameCompany) {
    const MOTHER = '1';
    const data = {
      adjuntos: [],
      dnt: {
        tipo: 'EXP',
        tipoFlujo: 1,
        origen: input.origin,
        emisorRut: iutCompany,
        receptorRut: iutCompany,
        emisorRazonSocial: nameCompany,
        receptorRazonSocial: nameCompany,
        claseMercadoPublico: 'ext',
        numeroExt: input.numberExp,
        compradorArea: input.sender,
        compradorCodigo: input.senderType,
        despachoContactoRut: input.senderIut,
        despachoContactoNombre: input.senderName,
        emisorDireccion: input.senderAddress,
        emisorComuna: input.senderComune,
        despachoContactoEmail: input.senderEmail,
        despachoContactoTelefono: input.senderPhone,
        estado: input.isExternal ? 1 : 2,
        estadoCodigoEstadoComprador: MOTHER,
        emisorCentroCostoNumero: input.documentType,
        emisorSucursalPais: input.documentTypeId,
        emisorCentroCostoNombre: input.documentTypeName,
        emisorContactoCodigo: input.documentCode,
        emisorContactoNombre: input.senderName,
        emisorContactoEmail: input.senderEmail,
        emisorContactoTelefono: input.senderPhone,
        emisorSucursalCodigo: input.process,
        emisorSucursalDireccion: input.subProcess,
        transportePuertoNombre: input.processName,
        transportePuertoPais: input.subProcessName,
        numeroInt: input.documentNumber,
        nombreDescriptivo: input.description,
        emisorContactoRut: input.senderCompanyIut,
        emisorContactoArea: input.senderCompanyName !== '' ? input.senderCompanyName : input.senderName,
        transporteTransportistaCargo: input.senderAgency,
        transporteNotas: input.officeName,
        transporteEmbalajeTara: input.subjectOffice,
        transportePuertoCodigo: input.rifCode,
        transportePuertoTipo: input.isPrivate,
        emisorInfoAdicional: input.linkToFolder,
        transporteEmbalajeSello: input.entryFormatFile,
        condicionDespacho: input.fileNumberEntry,
        compradorEmail: input.numberRidex,
        compradorTelefono: input.numberSac
      },
      destinatarios: [
        ...(input.subjectsSelected || []).map((subject) => ({
          tipoDestino: 1,
          estado: 1,
          destinoCodigoId: subject.subjectType.id,
          destinoCodigo: subject.subjectType.value,
          destinoNombre: subject.subjectType.label,
          destinoListaCodigoId: subject.subject.id,
          destinoListaCodigo: subject.subject.value,
          destinoListaNombre: subject.subject.label,
          destinoCorreo: subject.subjectEmail,
          providenciaId: subject.providence,
          providenciaVencimiento: subject.providenceExpiration,
        })),
        ...(input.copiesSelected || []).map((subject) => ({
          tipoDestino: 2,
          estado: 1,
          destinoCodigoId: subject.copySubjectType.id,
          destinoCodigo: subject.copySubjectType.value,
          destinoNombre: subject.copySubjectType.label,
          destinoListaCodigoId: subject.copySubject.id,
          destinoListaCodigo: subject.copySubject.value,
          destinoListaNombre: subject.copySubject.label,
          destinoCorreo: subject.copySubjectEmail,
          providenciaId: subject.providence,
          providenciaVencimiento: subject.providenceExpiration,
        }))
      ],
      referencias: (input.relatedDocumentsSelected || []).map((relatedDocument) => ({
        linea: relatedDocument.id,
        tipoDocumento: relatedDocument.type,
        folio: relatedDocument.number
      }))
    };

    if (input.solicitanteDocumentoId) {
      data.dnt.solicitanteRut = input.solicitanteRut;
      data.dnt.solicitanteNombre = input.solicitanteNombre;
      data.dnt.solicitanteEmail = input.solicitanteEmail;
      data.dnt.solicitanteDocumentoId = input.solicitanteDocumentoId;
    }

    if (input.matter) {
      data.observaciones = [
        {
          linea: '0',
          observacion: input.matter
        }
      ];
    }
    if (input.issueDate) {
      data.dnt.fechaEmision = Vue.moment(input.issueDate).format('YYYY-MM-DD');
    }
    if (input.mainFile) {
      data.adjuntos = [
        ...data.adjuntos,
        {
          tipo: 'principal',
          adjuntoMime: input.mainFile.mime,
          adjuntoNombre: input.mainFile.name,
          fecha: input.mainFile.date,
          adjuntoUrl: input.mainFile.path,
          tipoDescripcion: input.mainFile.currentDescription,
          otraReferenciaId: input.mainFile.format,
          ...(input.mainFile.id && { adjuntoId: input.mainFile.id }),
          ...(input.mainFile.status && { estado: input.mainFile.status })
        }
      ];
    }
    if (input.additionalFiles && input.additionalFiles.length) {
      data.adjuntos = [
        ...data.adjuntos,
        ...(input.additionalFiles || []).map((file) => ({
          tipo: 'adjunto',
          adjuntoMime: file.mime,
          adjuntoNombre: file.name,
          fecha: file.date,
          adjuntoUrl: file.path,
          tipoDescripcion: file.currentDescription,
          otraReferenciaId: file.format,
          ...(file.id && { adjuntoId: file.id }),
          ...(file.status && { estado: file.status })
        }))
      ];
    }

    return data;
  }
});
